import { SharedConstants } from "../../../../../shared/constants/shared.constants";
export class ViewApplicationLocationWConstants {
    static STEP_TITLE = "Location";
    static SAVE_BUTTON_PLACEHOLDER = SharedConstants.SAVE_LABEL;
    static DESCRIPTION_LABEL_1 = "Please draw a point, line or polygon on the map to indicate the location of the wayleave.";
    static TRUE_CENTROID = "True centroid gp shared-services";
}
